import styles from './SignupContent.module.scss'
import { SignupStep1 } from './SignupStep1/SignupStep1'
import { SignupStep2 } from './SignupStep2/SignupStep2'
import { SignupStep3 } from './SignupStep3/SignupStep3'
import { SignupStepPublicEdit } from './SignupStepPublicEdit/SignupStepPublicEdit'
import { useNavigate } from 'react-router-dom'
import { Icon } from 'components/Icon/Icon'
import { useAppDispatch, useAppSelector } from 'redux/hooks'
import { nextStep, previousStep } from 'redux/rootSlice/rootSlice'


type Props = {
    onSubmit?: () => void;
}

export function SignupContent(props: Props) {
    const { signupStep } = useAppSelector((state) => state.root)

    const dispatch = useAppDispatch()
    const navigate = useNavigate()

    function handleNextStep() {
        dispatch(nextStep())
    }

    function submitFinish() {
        navigate('/request')
    }

    function handlePreviousStep() {
        dispatch(previousStep())
    }

    const isSignupContent = signupStep <= 3

    function switchSignup(type) {
        switch (type) {
            case 1:
                return <SignupStep1 onSubmit={handleNextStep} />
            case 2:
                return <SignupStep2 onSubmit={handleNextStep} />
            case 3:
                return <SignupStep3 onSubmit={handleNextStep} />
            case 4:
                return <SignupStepPublicEdit onSubmit={submitFinish} />
        }
    }


    return (
        <div>
            {isSignupContent ? (
                <span className={styles['step']}>{signupStep}/3</span>
            ) : (
                <div className={styles['back']} onClick={handlePreviousStep}>
                    <Icon name='back' />
                    back
                </div>
            )}
            {switchSignup(signupStep)}
        </div>
    );
}

